import { render } from "./websocket.vue?vue&type=template&id=7605b0c3&ts=true"
import script from "./websocket.vue?vue&type=script&lang=ts"
export * from "./websocket.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__